// extracted by mini-css-extract-plugin
module.exports = {"preloader":"_80ad21f8ef--preloader--2tbT6","container":"_80ad21f8ef--container--2ttQ_","modal-title":"_80ad21f8ef--modal-title--uORAo","img":"_80ad21f8ef--img--3VPm3"};